'use strict';

angular.module('mobile-apps')
	.service('EntryDetail', ['$modal', function($modal) {

		function openModal(mobileAppId, languageId, groupId, entryId, entryIndex) {

			var modalWindowClass = 'backdrop-' + entryId;

			var modalOpen = $modal.open({
				templateUrl: 'modules/mobile-apps/views/language-entry-detail-modal.client.view.html',
				controller: [
					'$scope',
					'$rootScope',
					'$timeout',
					'$state',
					'$aside',
					'$q',
					'$modalInstance',
					'EventTracker',
					'SweetAlert',
					'Utilities',
					'LockEntry',
					'AvailableLanguages',
					'Authentication',
					'LanguageEntries',
					'EntryMain',
					'GlossaryMain',
					function (
						$scope,
						$rootScope,
						$timeout,
						$state,
						$aside,
						$q,
						$modalInstance,
						EventTracker,
						SweetAlert,
						Utilities,
						LockEntry,
						AvailableLanguages,
						Authentication,
						LanguageEntries,
						EntryMain,
						GlossaryMain
					) {
						$scope.authentication = Authentication;

						$scope.loading = true;
						$scope.modalTitle = '';
						$scope.showPreviousButton = false;
						$scope.showNextButton = false;

						$scope.mobileAppId = mobileAppId;
						$scope.languageId = languageId;
						$scope.groupId = groupId;
						$scope.entryId = entryId;
						$scope.languageEntry = {
							key: '',
							value: '',
							description: '',
							group: groupId, 
							metadata: []
						};
						$scope.languageEntryStart = {};
						$scope.sourceLanguageToShow = 'en'; // Set reasonable default till actualy value set
						$scope.availableLanguages = AvailableLanguages.get();

						modalOpen.rendered.then(
						  function(data) {

						  	// Custom code to make it possible again to close
						    // on backdrop click and esc-press with check if
							// data changed.
						  	$timeout(function() {

						  		// Close on backdrop click
								var modalBackdropElement = document.querySelector('.' + modalWindowClass);
								var modalBackdrop = angular.element(modalBackdropElement);

								var onBackdropClick = function (e) {
									$scope.closeWithUnsavedCheck();
								};
								modalBackdrop.on('click', onBackdropClick);
								$scope.$on('$destroy', function () {
									modalBackdrop.off('click', onBackdropClick);
								});

								// Close when esc pressed
								modalBackdrop.bind('keydown keypress', function (e) {
									if(e.which === 27) { // 27 = esc key
										$scope.closeWithUnsavedCheck();
									}
								});

								// Make sure that we do not close when people
								// click on the content or anything on it.
								var modalContentElement = document.querySelector('.modal-content');
								var modalContent = angular.element(modalContentElement);
								var onModalContentClick = function (e) {
									e.stopPropagation();
								};
								modalContent.on('click', onModalContentClick);
								$scope.$on('$destroy', function () {
									modalContent.off('click', onModalContentClick);
								});
							});

						  }
						);


						/**
						 * Returns the last part of the name of the current state
						 */
						$scope.getLastStatePart = function() {
							var stateParts = $state.current.name.split('.');
							return stateParts[stateParts.length-1];
						};


						/**
						 * Sets the start value data to be able to check if
						 * changes have been made
						 */
						$scope.setStartValue = function() {
							$scope.languageEntryStart = JSON.parse(JSON.stringify($scope.languageEntry));
						};


						/**
						 * Returns if there are currently any unsaved changes
						 */
						$scope.hasUnsavedChanges = function() {
							var checkProperties = [
								'key',
								'description',
								'draft',
								'value',
								'maxLength',
								'group'
							];

							var parameterName;
							for (var i=0; i<checkProperties.length; i++) {
								parameterName = checkProperties[i];
								if ($scope.languageEntry[parameterName] !== $scope.languageEntryStart[parameterName]) {
									return true;
								}
							}

							return false;
						};


						/**
						 * Checks if there are unsaved changes and if any have been found check
						 * with user if they should be discarded
						 */
						$scope.checkUnsavedChangesProceed = function() {
							if (!$scope.hasUnsavedChanges()) {
								// No unsaved changes so go on
								return $q.when(true);
							}

							// There are unsaved changes so check with user if they
							// should be discarded
							return $q(function(resolve, reject) {
								$timeout(function() {
									SweetAlert.swal(
										{
											title: 'Unsaved changes',
											text: 'There are unsaved changes. Do you want to discard the changes and proceed?',
											type: 'warning',
											showCancelButton: true,
											confirmButtonColor: '#DD6B55',
											confirmButtonText: 'Yes, discard changes!',
											cancelButtonText: 'No, cancel!',
											closeOnConfirm: true,
											closeOnCancel: true
										},
										function (isConfirm) {
											return resolve(isConfirm);
										}
									);
								}, 50);
							});
						};


						/**
						 * Returns the role of the currently logged in user in
						 * the app
						 */
						$scope.getCurrentRoleInApp = function () {
							var team = $scope.mobileApp.team;
							var userId = $scope.authentication.user._id;
							for (var i = 0; i < team.members.length; i++) {
								if (userId === team.members[i].user) {
									$scope.roleInApp = team.members[i].role;
								}
							}
						};


						/**
						 * Displays the loading screen
						 */
						$scope.showLoading = function (loading) {
							$timeout(function() {
								$scope.loading = loading;
							});
						};


						/**
						 * Closes modal and returns the given data.
						 * If there are unsaved changes it checks first
						 * with the user if he really wants to lose the changes.
						 */
						$scope.closeWithUnsavedCheck = function(data) {
							$scope.checkUnsavedChangesProceed()
								.then(
									function(proceed) {
										if (proceed) {
											$scope.close(data);
										}
									}
								);
						};


						/**
						 * Closes modal and returns the given data
						 */
						$scope.close = function(data) {
							var lastStatePart = $scope.getLastStatePart();

							// Set the state it it is not set already
							if (['edit', 'new'].indexOf(lastStatePart) !== -1) {
								$state.go('^', {}, {inherit: true, notify: false});
							}

							$rootScope.$broadcast('EntryDetailClosed', null);
							$modalInstance.close(data);
						};


						/**
						 * Sets the current draft as new value
						 */
						$scope.approveDraft = function (langEntry, event) {
							event.preventDefault();
							var draft = langEntry.draft;
							$scope.languageEntry.draft = '';
							$scope.languageEntry.value = draft;
						};


						/**
						 * Show history of entry
						 */
						$scope.toggleHistory = function(){
							var changeLog = {};
							changeLog.headline = 'for ID: ' + $scope.languageEntry.key;
							changeLog.query = {
								key: $scope.languageEntry.key
							};

							var asideInstance = $aside.open({
								templateUrl: 'modules/mobile-apps/views/changelog.client.view.html',
								controller: 'ChangelogController',
								placement: 'left',
								size: 'lg',
								resolve: {
									loadData: changeLog
								}
							});
						};


						$scope.switchSourceLanguageInEditView = function (sourceLanguage) {
							$scope.sourceLanguage = _.find($scope.languages, {name: sourceLanguage});
							if (!$scope.languageEntryMap[sourceLanguage]) {
								var params = {
									mobileAppId: $scope.mobileAppId,
									languageId: $scope.sourceLanguage._id,
									entryId: $scope.entryId
								};
								$scope.languageEntryMap[$scope.sourceLanguage.name] = LanguageEntries.get(params);
							}
						};


						/**
						 * Create new entry
						 */
						$scope._create = function (cb) {

							var languageEntryData = {
								key: $scope.languageEntry.key,
								value: $scope.languageEntry.value,
								description: $scope.languageEntry.description,
								draft: $scope.languageEntry.draft,
								group: $scope.languageEntry.groups,
								metadata: $scope.languageEntry.metadata
							};

							if ($scope.languageEntry.maxLength !== '') {
								languageEntryData.maxLength = parseInt($scope.languageEntry.maxLength);
							}

							var languageEntry = new LanguageEntries(languageEntryData);

							// Create entry
							languageEntry.$save({
								mobileAppId: $scope.mobileAppId,
								languageId: $scope.languageId,
								groupId: $scope.groupId
							}, function (response) {
								// Track the Entry Create, for the values value, draft and
								// save only if they got set or not
								var eventData = {
									key: $scope.languageEntry.key,
									value: !!$scope.languageEntry.value,
									draft: !!$scope.languageEntry.draft,
									description: !!$scope.languageEntry.description
								};
								EventTracker.track('Entry Create Success', 'Entry Create', eventData);

								// Makes sure that the entry list gets reloaded
								// so that the new entry does get displayed
								$rootScope.$broadcast('entriesChanged');
								// $rootScope.$broadcast('entryChanged', {entry: response});

								return cb(null, response);
							}, function (errorResponse) {
								return cb(errorResponse);
							});
						};


						/**
						 * Update existing Language entry
						 */
						$scope._update = function (callback) {

							var languageEntry = $scope.languageEntry;

							languageEntry.$update({
								mobileAppId: $scope.mobileAppId,
								languageId: $scope.languageId,
								entryId: $scope.entryId
							}, function (response) {

								if ($scope.languageEntry.group !== $scope.languageEntryStart.group) {
									// Makes sure that the entry list gets reloaded
									// so that the entry does not get displayed under
									// the current group anymore.
									$rootScope.$broadcast('entriesChanged');
								}

								$rootScope.$broadcast('entryChanged', {entry: response});

								if (angular.isFunction(callback)) {
									callback(null, response);
								}
							}, function (errorResponse) {
								if (angular.isFunction(callback)) {
									callback(errorResponse);
								}
							});
						};


						/**
						 * Removes the entry
						 */
						$scope.remove = function (cb) {
							// Track the Entry Delete, for the values value and draft
							// save only if they were set or not
							var eventData = {
								key: $scope.languageEntry.key,
								value: !!$scope.languageEntry.value,
								draft: !!$scope.languageEntry.draft,
								description: !!$scope.languageEntry.description
							};

							$scope.languageEntry.$remove({
								mobileAppId: $scope.mobileAppId,
								languageId: $scope.languageId
							}, function () {
								// Makes sure that the entry list gets reloaded
								// so that the deleted entry does not get displayed
								// anymore
								$rootScope.$broadcast('entriesChanged');

								// Reload the tags that not deleted entries
								// do not get displayed as part of a tag
								$rootScope.$broadcast('tagsChanged');

								EventTracker.track('Entry Delete Success', 'Entry Delete', eventData);

								if (angular.isFunction(cb)) {
									cb();
								}
							}, function (errorResponse) {
								return cb(errorResponse);
							});
						};


						$scope.showLockToggleModal = function () {
							var text = '';
							var title = '';
							var singleBtn = $scope.availableLanguages[$scope.language.name];
							var allBtn = 'All languages';
							var lock = true;
							if ($scope.languageEntry.locked) {
								title = 'Unlock entry?';
								text = 'Unlock this entry for ' + $scope.availableLanguages[$scope.language.name] + ' only or for all languages?';
								lock = false;
							} else {
								title = 'Lock entry?';
								text = 'Lock this entry for ' + $scope.availableLanguages[$scope.language.name] + ' only or for all languages? Locked entries will not be available for translators.';
								lock = true;
							}
							$timeout(function() {
								SweetAlert.swal({
									title: title,
									text: text,
									type: 'warning',
									allowEscapeKey: false,
									showCancelButton: true,
									confirmButtonColor: '#3099d5',
									cancelButtonColor: '#3099d5',
									confirmButtonText: singleBtn,
									cancelButtonText: allBtn,
									closeOnConfirm: true,
									closeOnCancel: true
								}, function (isconfirm) {
									$scope.languageEntry.locked = lock;
									var errorCallback = function (errorResponse) {
										$scope.error = errorResponse.data.message;
										$scope.languageEntry.locked = !lock;
									};
									var successCallback = function(data) {
										$scope.languageEntry.valueUpdatedAt = new Date();
										$rootScope.$broadcast('entryChanged', {entry: $scope.languageEntry});
									};
									if (isconfirm) {
										if (lock) {
											LockEntry.lock({
												mobileAppId: $scope.mobileAppId,
												languageId: $scope.languageId,
												entryId: $scope.entryId
											}, null, successCallback, errorCallback);
										} else {
											LockEntry.unlock({
												mobileAppId: $scope.mobileAppId,
												languageId: $scope.languageId,
												entryId: $scope.entryId
											}, null, successCallback, errorCallback);
										}
									} else {
										if (lock) {
											LockEntry.lockAll({
												mobileAppId: $scope.mobileAppId,
												entryId: $scope.entryId
											}, null, successCallback, errorCallback);
										} else {
											LockEntry.unlockAll({
												mobileAppId: $scope.mobileAppId,
												entryId: $scope.entryId
											}, null, successCallback, errorCallback);
										}
									}
								});
							}, 50);
						};


						$scope.openDeleteLanguageEntryModal = function () {
							$timeout(function() {
								SweetAlert.swal(
									{
										title: 'Are you sure?',
										text: 'This will delete the Translation ID "' + $scope.languageEntry.key + '" in all languages. This can not be recovered!',
										type: 'warning',
										showCancelButton: true,
										confirmButtonColor: '#DD6B55',
										confirmButtonText: 'Yes, delete it!',
										cancelButtonText: 'No, cancel!',
										closeOnConfirm: true,
										closeOnCancel: true
									},
									function (isConfirm) {
										if (isConfirm) {
											$scope.remove(function (err) {
												if (err) {
													Utilities.showMessageErrorResponse(err);
													return;
												}
												return $scope.close();
											});
										}
									}
								);
							}, 50);
						};


						$scope.save = function () {

							if ($scope.entryId) {
								// Edit existing translation
								$scope._update(function (err, response) {
									if (err) {
										Utilities.showMessageErrorResponse(err);
										return;
									}

									return $scope.close();
								});
							} else {
								// Create new translation
								$scope._create(function (err, response) {
									if (err) {
										Utilities.showMessageErrorResponse(err);
										return;
									}

									return $scope.close();
								});
							}

						};


						/**
						 * Goes to the previous entry
						 */
						$scope.goToPrevious = function () {
							$scope.checkUnsavedChangesProceed()
								.then(
								  function(proceed) {
								    if (proceed) {
											$rootScope.$broadcast('liveEditEntrySelectIndex', {index: --entryIndex, direction: 'negative', openEditModal: true});
											return $scope.close();
										}
								  }
								);
						};


						/**
						 * Goes to the next entry
						 */
						$scope.goToNext = function () {
							$scope.checkUnsavedChangesProceed()
								.then(
									function(proceed) {
										if (proceed) {
											$rootScope.$broadcast('liveEditEntrySelectIndex', {index: ++entryIndex, direction: 'positive', openEditModal: true});
											return $scope.close();
										}
									}
								);
						};


						$scope.initEditTranslation = function() {
							var lastStatePart = $scope.getLastStatePart();

							// Set the state it it is not set already
							if (lastStatePart !== 'edit') {
								$state.go('.edit', {entryId: $scope.entryId}, {inherit: true, notify: false});
							}

							// Load all entries because we need it to know if
							// the next button should be displayed or not
							EntryMain.loadEntries($scope.mobileAppId, $scope.groupId, [$scope.languageId], false)
								.then(
									function(data) {

										var numEntries = 0;
										if (EntryMain.entryKeyMap.hasOwnProperty(groupId)) {
											numEntries = EntryMain.entryKeyMap[groupId].length;
										}

										if (entryIndex > 1) {
											$scope.showPreviousButton = true;
										}

										if (entryIndex < numEntries) {
											$scope.showNextButton = true;
										}
									}
								);

							// // Get the data of the entry to display
							EntryMain.loadEntry($scope.mobileAppId, $scope.languageId, $scope.entryId)
								.then(
									function(data) {
										$scope.showLoading(false);

										$scope.groups = EntryMain.groups;
										$scope.groupsArr = Object.values(EntryMain.groups);
										$scope.mobileApp = EntryMain.mobileApps[$scope.mobileAppId];
										
										$scope.languages = EntryMain.languages;
										$scope.language = EntryMain.languages[$scope.languageId];

										$scope.languageEntryMap = EntryMain.languageEntryMap;
										$scope.languageEntry = $scope.languageEntryMap[$scope.language.name];
										$scope.languageEntry.baseValue = $scope.languageEntryMap[$scope.mobileApp.baseLanguage].value;

										$scope.baseLanguage = _.find($scope.languages, {name: $scope.mobileApp.baseLanguage});
										$scope.sourceLanguage = _.find($scope.languages, {name: $scope.mobileApp.baseLanguage});
										$scope.isMasterLang = $scope.language.name === $scope.mobileApp.baseLanguage;

										$scope.sourceLanguageToShow = $scope.sourceLanguage.name;
										$scope.languageToShowEditMode = $scope.mobileApp.baseLanguage;
										
										// Add the language ids for the entry-warnings directive
										$scope.languagesWarning = {
											base: $scope.mobileApp.baseLanguage,
											entry: $scope.language.name
										};

										$scope.addMetadata();
										$scope.setStartValue();
										$scope.getCurrentRoleInApp();
									}
								)
								.catch(
									function(err) {
										Utilities.showMessageErrorResponse(err);
										$scope.showLoading(false);
									}
								);
						};


						$scope.initNewTranslation = function() {
							var lastStatePart = $scope.getLastStatePart();

							// Set the state it it is not set already
							if (lastStatePart !== 'new') {
								$state.go('.new', {}, {inherit: true, notify: false});
							}

							EntryMain.loadMobileApp($scope.mobileAppId, false, function(err, result) {
								$scope.showLoading(false);
								if (err) {
									Utilities.showMessageErrorResponse(err);
									return;
								}

								$scope.setStartValue();

								$scope.groups = EntryMain.groups;
								$scope.mobileApp = EntryMain.mobileApps[$scope.mobileAppId];
								$scope.languages = EntryMain.languages;
								$scope.language = EntryMain.languages[$scope.languageId];
								$scope.baseLanguage = _.find($scope.languages, {name: $scope.mobileApp.baseLanguage});
								$scope.isMasterLang = $scope.language.name === $scope.mobileApp.baseLanguage;

								$scope.addMetadata();
								$scope.getCurrentRoleInApp();
							});
						};

						$scope.addMetadata = function(){
							//Add metadata
							var currentMetadata =  $scope.languageEntry ? _.clone($scope.languageEntry.metadata) : null;
							var metadataBones = $scope.mobileApp.metadata ? _.clone($scope.mobileApp.metadata) : null;
							if(!currentMetadata && metadataBones && metadataBones.length){
								$scope.languageEntry.metadata = [];
								metadataBones.forEach(function(item){
									$scope.languageEntry.metadata.push({ 
										id: item.id, 
										key: item.fieldName, 
										value: null, 
										description: item.description,
										order: item.order 
									});
								});
							} else if(currentMetadata && metadataBones && currentMetadata.length !== metadataBones.length){
								$scope.languageEntry.metadata = [];
								metadataBones.forEach(function(item) {
									var currentMetadataItem, currentMetadataItemValue;
									if (currentMetadata && currentMetadata.length){
										currentMetadataItem =  currentMetadata.find(function (m){ return m.key === item.fieldName; });
									} else {
										currentMetadataItem = null;
									}
									if(currentMetadataItem){
										currentMetadataItemValue = currentMetadataItem.value;
									}else{
										currentMetadataItemValue = null;
									}
									$scope.languageEntry.metadata.push({ 
										id: item.id, 
										key: item.fieldName, 
										value: currentMetadataItemValue, 
										description: item.description,
										order: item.order 
									});
								});
							} else if(currentMetadata && metadataBones && currentMetadata.length === metadataBones.length){
								metadataBones.forEach(function(item, index) {
									var currentMetadataItem, currentMetadataItemValue;
									if(currentMetadata && currentMetadata.length){
										currentMetadataItem =  currentMetadata.find(function (m){ return m.key === item.fieldName; });
									}else{
										currentMetadataItem = null;
									}
									if(currentMetadataItem){
										currentMetadataItemValue = currentMetadataItem.value;
									}else{
										currentMetadataItemValue = null;
									}
									$scope.languageEntry.metadata[index] = { 
										id: item.id, 
										key: item.fieldName, 
										value: currentMetadataItemValue, 
										description: item.description,
										order: item.order 
									};
								});
							}
						};

						/**
						 * Initializes the view
						 */
						$scope.init = function() {
							$scope.showLoading(true);

							// Load the glossary data
							GlossaryMain.loadGlossary($scope.mobileAppId, true, function(err, entries) {});

							if ($scope.entryId) {
								// Edit existing translation
								$scope.modalTitle = 'Update Translation';
								$scope.initEditTranslation();
							} else {
								// Create new translation
								$scope.modalTitle = 'Add Translation';
								$scope.initNewTranslation();
							}
						};

						$scope.init();
					}],
				size: 'lg',
				backdrop: 'static',
				windowClass: modalWindowClass,
				keyboard: false
			});

			return modalOpen;
		}

		return {
			openModal: openModal
		};
	}]);
